
import React, { useState } from 'react';

const HEX_CODES = ['#EF4444', '#3B82F6', '#10B981', '#F59E0B', '#8B5CF6', '#EC4899'];

const Hex: React.FC = () => {
  const [target, setTarget] = useState(HEX_CODES[0]);
  const [score, setScore] = useState(0);

  const check = (code: string) => {
    if (code === target) {
      setScore(s => s + 1);
      setTarget(HEX_CODES[Math.floor(Math.random() * HEX_CODES.length)]);
    } else {
      setScore(0);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className="mb-12 text-center">
        <p className="text-xs text-slate-500 uppercase tracking-widest mb-2">TARGET HEX</p>
        <h2 className="text-5xl font-mono font-black mb-4" style={{ color: target }}>{target}</h2>
        <p className="text-xl font-bold">MATCHED: {score}</p>
      </div>
      <div className="grid grid-cols-3 gap-6">
        {HEX_CODES.map(c => (
          <button
            key={c}
            onClick={() => check(c)}
            className="w-20 h-20 rounded-2xl shadow-lg border-4 border-white/5 hover:scale-110 transition-transform"
            style={{ backgroundColor: c }}
          />
        ))}
      </div>
    </div>
  );
};

export default Hex;
